import { useEffect, useState } from "react";
import { api } from "../../lib/site";
import { Overline } from "./Primitives";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const FaqAccordion = ({ topic }) => {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    const url = topic ? `/faqs?topic=${topic}` : "/faqs";
    api.get(url).then((r) => setFaqs(r.data)).catch(() => {});
  }, [topic]);

  return (
    <section data-testid="faq-section" className="bg-brand-blush py-24 md:py-36">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center flex flex-col items-center mb-14">
          <Overline className="mb-5">FAQ</Overline>
          <h2 className="font-serif font-light text-brand-ink text-4xl sm:text-5xl tracking-tight">
            Questions, answered
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f) => (
            <AccordionItem
              key={f.id}
              value={f.id}
              data-testid={`faq-${f.id}`}
              className="bg-white rounded-2xl border border-brand-ink/10 px-6 overflow-hidden"
            >
              <AccordionTrigger className="text-left font-serif text-lg md:text-xl text-brand-ink hover:no-underline py-5">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-brand-ink/70 font-light leading-relaxed pb-6 text-base">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqAccordion;
